<template>
  <vx-card v-if="access !== null">
    <main class="w-full" ref="loadAbout">
      <div class="mb-6">
        <section class="mb-2 flex justify-start gap-1">
          <h6><strong>Edit Nama Aplikasi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          name="name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi dengan Nama Aplikasi"
        />
      </div>
      <div class="mb-6">
        <section class="mb-2 flex justify-start gap-1">
          <h6><strong>Edit Tentang</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vue-editor v-model="formData.tentang"></vue-editor>
      </div>
      <div class="mb-6">
        <section class="mb-2 flex justify-start gap-1">
          <h6><strong>Edit Kebijakan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vue-editor v-model="formData.kebijakan"></vue-editor>
      </div>
      <div class="mb-6">
        <section class="mb-2 flex justify-start gap-1">
          <h6><strong>Edit Syarat</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vue-editor v-model="formData.syarat"></vue-editor>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button
          color="danger"
          class="mr-2 rounded-2xl"
          v-if="access.delete === 1"
          @click="dialogDelete(id)"
          :disabled="id === null"
          >Reset</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          v-if="access.create === 1 && access.update === 1"
          @click="addData"
          :disabled="!validateForm"
          >Save</vs-button
        >
      </div>
    </footer>
  </vx-card>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      access: null,
      id: null,
      formData: {
        name: "",
        tentang: "",
        kebijakan: "",
        syarat: "",
      },
    };
  },
  computed: {
    validateForm() {
      return (
        this.formData.name !== "" &&
        this.formData.tentang !== "" &&
        this.formData.kebijakan !== "" &&
        this.formData.syarat !== ""
      );
    },
  },
  methods: {
    setData(v) {
      this.id = v.id;
      this.formData.name = v.name;
      this.formData.tentang = this.richtTextFormat(v.tentang);
      this.formData.kebijakan = this.richtTextFormat(v.kebijakan);
      this.formData.syarat = this.richtTextFormat(v.syarat);
    },
    resetData() {
      this.id = null;
      this.formData.name = "";
      this.formData.tentang = "";
      this.formData.kebijakan = "";
      this.formData.syarat = "";
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadAbout,
        color: "primary",
      });
      this.$store
        .dispatch("about/getAbout", {})
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadAbout);
          if (v.data.length !== 0) {
            this.setData(v.data[0]);
          } else {
            this.resetData();
          }
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadAbout);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    dialogDelete(id) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Reset About ?",
        text: "Anda yakin ingin menghapus semua perubahan about",
        accept: () => {
          this.delete(id);
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadUsers,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("about/cudAbout", [{ id: id, ...fungsi }])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title: "Me-reset Ulang Sukses!",
            text: `About berhasil di reset`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadUsers);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let idData = {};
      if (this.id !== null) {
        idData = {
          id: this.id,
        };
      }
      this.$store
        .dispatch("about/cudAbout", [{ ...this.formData, ...idData }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title: this.id !== null ? "Edit About Sukses!" : "Tambah ABout Sukses!",
            text: this.id !== null ? `About Berhasil diedit` : `About Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    if (this.$store.state.about.about.length !== 0) {
      this.setData(this.$store.state.about.about[0]);
    } else {
      this.getData();
    }
  },
  created() {
    if (this.$store.state.auth.profileAccess !== null) {
      if (
        this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/about"
        )
      ) {
        this.access = this.$store.state.auth.profileAccess.menu.find(
          (e) => e.menu.url === "/dashboard/about"
        );
      }
    }
  },
};
</script>
